import showcase from './showcase'
import themeChose from './themeChose'
import cases from './case'

export default [showcase, themeChose, cases]
